const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Request Your Quote',
    desc: 'Call us or fill out the quick form. We\'ll ask a few simple questions and give you a clear price — no surprises.',
    color: 'bg-teal-600',
  },
  {
    number: '02',
    icon: 'ri-calendar-2-line',
    title: 'Schedule Your Service',
    desc: 'Pick a time that works for you. We work around your schedule and show up on time, every single time.',
    color: 'bg-teal-700',
  },
  {
    number: '03',
    icon: 'ri-sparkling-2-line',
    title: 'Enjoy the Results',
    desc: 'Watch your property transform. We clean up after ourselves and leave you with a home that looks brand new.',
    color: 'bg-teal-800',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block bg-teal-100 text-teal-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            From Quote To Clean in 3 Simple Steps
          </h2>
          <p className="text-slate-500 text-lg max-w-lg mx-auto">
            We make the whole process easy. No waiting weeks. No confusing contracts.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector Line (desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-full w-full h-0.5 bg-teal-200 z-10" style={{ width: 'calc(100% - 5rem)', left: 'calc(50% + 2.5rem)' }}></div>
              )}

              <div className="text-center">
                {/* Number + Icon Circle */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className={`w-24 h-24 flex items-center justify-center rounded-full ${step.color}`}>
                    <i className={`${step.icon} text-white text-3xl`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center rounded-full bg-orange-500">
                    <span className="text-white text-xs font-black">{step.number}</span>
                  </div>
                </div>

                <h3 className="text-slate-900 font-black text-xl mb-3">{step.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed max-w-xs mx-auto">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-3 bg-teal-50 border border-teal-200 rounded-2xl px-6 py-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-100">
              <i className="ri-time-line text-teal-600 text-lg"></i>
            </div>
            <div className="text-left">
              <p className="text-slate-800 font-bold text-sm">Takes less than 2 minutes to request a quote.</p>
              <p className="text-slate-500 text-xs">We respond the same day — usually within the hour.</p>
            </div>
            <a
              href="#contact"
              className="ml-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
